// extracted by mini-css-extract-plugin
export default {"sidebar-toggle":"style_sidebar-toggle__ebWs2"};